const skuToIgnoreCOD = ["40654263582755","40654263615523","40654391771171","40654391803939","40660195999779","40654455144483","40654455177251","40660227063843","40654274756643","40654274789411","40654366965795","40654366998563","40654323122211","40654323154979","40654318305315","40654318338083","40654332362787","40654332395555","40660223033379","40660223066147","40654511767587","40654511800355","40660224409635","40654473101347","40654473134115","40654478868515","40654478901283","40654504099875","40654504132643","40654413168675","40654413201443","40654444167203","40654444199971","40654444167203","40654444199971","40654428897315","40654428930083","40660223459363","40660224770083","40660223098915","40654310015011","40654310047779","40654252900387","40654252933155","40654282326051","40654282358819","40654251622435","40654251655203","40660224344099","40660224081955","40660225392675","40660225622051","40660226408483","40654275379235","40654275412003","40660227784739","40660224475171","40660224835619"] 
const skuToAppendCOD = [] 

window.checkCODAvailability = function (skuList) {
  let ignoreCOD = false;
  let appendCOD = false;

  if (!Array.isArray(skuList)) {
    return null;
  }

  for (let i = 0; i < skuList.length; i++) {
    const currentSKU = skuList[i];
    if (typeof currentSKU !== "string") {
      return null;
    } else {
      if (skuToIgnoreCOD.includes(currentSKU)) {
        ignoreCOD = true;
      }
    }
  }

  if (skuToAppendCOD.length > 0 && skuList.length > 0) {
    appendCOD = skuList.every((element) => skuToAppendCOD.includes(element));
  }

  if (ignoreCOD) {
    return false;
  }

  if (!ignoreCOD && appendCOD) {
    return true;
  }

  return null;
};
